// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14e80e52","239":"2ceae0cf","455":"40707b32"}[chunkId] + ".chunk.js";
};